var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 118,
  height: 120,
  viewBox: "0 0 118 120"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Lower_Layer_ShopifyIcon",
  x: 0,
  y: 0,
  width: 114,
  height: 114,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: -2,
  dy: -3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  floodOpacity: 0.478
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Upper_Layer_ShopifyIcon",
  x: 4,
  y: 6,
  width: 114,
  height: 114,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.239
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Shopify",
  transform: "translate(-1095 -1018)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1095, 1018)",
  filter: "url(#Lower_Layer_ShopifyIcon)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Lower_Layer_ShopifyIcon-2",
  "data-name": "Lower_Layer_ShopifyIcon",
  cx: 48,
  cy: 48,
  r: 48,
  transform: "translate(11 12)",
  fill: "#5e8e3e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1095, 1018)",
  filter: "url(#Upper_Layer_ShopifyIcon)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Upper_Layer_ShopifyIcon-2",
  "data-name": "Upper_Layer_ShopifyIcon",
  cx: 48,
  cy: 48,
  r: 48,
  transform: "translate(11 12)",
  fill: "#95bf46"
})), /*#__PURE__*/React.createElement("path", {
  id: "ShopifyLogo_Base",
  d: "M-7901.692,3088.682a.574.574,0,0,0-.518-.481c-.214-.018-4.773-.356-4.773-.356s-3.166-3.142-3.515-3.49a1.439,1.439,0,0,0-1.29-.164c-.038.011-.692.212-1.772.547-1.058-3.042-2.923-5.838-6.207-5.838-.091,0-.183,0-.277.009a3.992,3.992,0,0,0-3.09-1.771c-7.648,0-11.3,9.563-12.448,14.421-2.972.92-5.083,1.575-5.352,1.659-1.66.521-1.712.573-1.929,2.136-.165,1.184-4.5,34.752-4.5,34.752l33.822,6.336,18.327-3.964s-6.434-43.5-6.474-43.794m-13.736-3.366-2.862.885v-.617a14.018,14.018,0,0,0-.684-4.621c1.693.212,2.818,2.137,3.544,4.353m-5.643-3.977a14.175,14.175,0,0,1,.777,5.152v.332l-5.911,1.83c1.138-4.393,3.271-6.515,5.135-7.314m-2.271-2.152a1.723,1.723,0,0,1,.98.332c-2.451,1.153-5.079,4.058-6.188,9.86l-4.672,1.446c1.3-4.425,4.387-11.638,9.881-11.638",
  transform: "translate(9075.367 -2030.136)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "ShopifyLogo_S",
  d: "M-7918.463,3110.621l-1.844,5.487a8.481,8.481,0,0,0-3.6-.863c-2.9,0-3.049,1.823-3.049,2.282,0,2.506,6.531,3.465,6.531,9.335,0,4.618-2.928,7.591-6.878,7.591a9.572,9.572,0,0,1-7.162-2.95l1.271-4.192s2.49,2.139,4.592,2.139a1.853,1.853,0,0,0,1.932-1.872c0-3.269-5.359-3.414-5.359-8.786,0-4.52,3.246-8.895,9.795-8.895a8.061,8.061,0,0,1,3.771.723",
  transform: "translate(9072.462 -2041.901)",
  fill: "#5e8e3e"
}), /*#__PURE__*/React.createElement("path", {
  id: "ShopifyLogo_SideShadow",
  d: "M-7881.6,3092.492c-.212-.018-4.711-.356-4.711-.356s-3.125-3.143-3.469-3.491a.838.838,0,0,0-.481-.224l-2.524,52.324,18.086-3.965s-6.349-43.508-6.39-43.807a.569.569,0,0,0-.511-.481",
  transform: "translate(9054.853 -2034.441)",
  fill: "#5e8e3e"
}))));
export default __webpack_public_path__ + "static/media/shopify2.6819b140.svg";
export { SvgComponent as ReactComponent };